import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';

import { UpsertUserData } from '../upsert-user';
import { UserRole } from '../user-role';

export interface IUserBaseForm {
    form: FormGroup;
    role: UserRole | unknown;
}

export enum UserBaseFormControls {
    Role = 'role',
    Email = 'email',
    Username = 'username',
    Description = 'description'
}

export class UserBaseForm implements IUserBaseForm {
    form: FormGroup;
    role: UserRole | null = null;
    userDetails: UpsertUserData | null = null;

    constructor() {
        this.form = new FormGroup({});

        this.form.addControl(UserBaseFormControls.Role, new FormControl('', [Validators.required]), {
            emitEvent: false
        });
        this.form.addControl(UserBaseFormControls.Email, new FormControl('', [Validators.required, Validators.email]), {
            emitEvent: false
        });
        this.form.addControl(UserBaseFormControls.Username, new FormControl('', [Validators.required]), {
            emitEvent: false
        });
        this.form.addControl(UserBaseFormControls.Description, new FormControl(''), {
            emitEvent: false
        });
    }

    validateForm(): void {
        _.values(this.form.controls).forEach(this.markForValidation);
        this.markForValidation(this.form);
    }

    clearForm(): void {
        this.form.reset();
        this.form.get(UserBaseFormControls.Role)?.setValue(this.role, { emitEvent: false });
    }

    applyUserDetails(userDetails?: UpsertUserData): void {
        this.form.addControl('id', new FormControl(userDetails?.id ?? ''), { emitEvent: false });
        this.form.get(UserBaseFormControls.Email)?.setValue(userDetails?.email ?? '', { emitEvent: false });
        this.form.get(UserBaseFormControls.Username)?.setValue(userDetails?.username ?? '', { emitEvent: false });
        this.form.get(UserBaseFormControls.Description)?.setValue(userDetails?.description ?? '', { emitEvent: false });
    }

    setEditMode(): void {
        this.form.get(UserBaseFormControls.Role)?.disable({ emitEvent: false });
        this.form.get(UserBaseFormControls.Email)?.disable({ emitEvent: false });
        this.form.get(UserBaseFormControls.Username)?.disable({ emitEvent: false });
    }

    private markForValidation(control: AbstractControl): void {
        control.markAsDirty();
        control.markAsTouched();
        control.updateValueAndValidity();
    }
}
